import React, { Component } from 'react';
import './field.css';
import { APP_CONST } from '../../constants';
import { Utils } from '../../services';

import { 
	GeckoFieldPassword,
	GeckoFieldText,
	GeckoFieldToggle
} from './types';

class GeckoField extends Component {

	// Map field types to field components
	types = {
		[APP_CONST.FIELD_TYPE_EMAIL]: GeckoFieldText,
		[APP_CONST.FIELD_TYPE_PASSWORD]: GeckoFieldPassword,
		[APP_CONST.FIELD_TYPE_TEXT]: GeckoFieldText,
		[APP_CONST.FIELD_TYPE_TEL]: GeckoFieldText,
		[APP_CONST.FIELD_TYPE_TOGGLE]: GeckoFieldToggle,
	};

	field() {
		return this.props.field;
	}

	type() {
		return this.field().type || APP_CONST.FIELD_TYPE_TEXT;
	}

	renderClasses() {
		const errors = this.errors();
		return Utils.classNames(`gecko-field gecko-field-type-${this.type()} ${errors.length ? 'has-errors' : ''}`);
	}

	renderFor() {
		return `field_${this.field().key}`;
	}

	isRequired() {
		return this.field().required || (this.field().requiredWhen ? this.field().requiredWhen() : false);
	}

	renderRequired() {
		if (this.isRequired()) return (<span className="required">*</span>);
		return null;
	}

	renderField() {
		const Field = this.types[this.type()];
		return <Field field={this.field()} values={this.props.values} handler={this.props.handler.bind(this)} />;
	}

	renderDescription() {
		if (this.field().description) {
			return <p className="description">{this.field().description}</p>
		}
		return null;
	}

	errors() {
		const extractErrors = (errors) => {
			if(typeof errors === 'function') {
				return extractErrors(errors(this.props.values[this.field().key], this.field(), this.props.values));
			}
			if(Array.isArray(errors)) {
				return errors;
			}
			if(errors) {
				return [errors];
			}
			return [];
		}
		return extractErrors.bind(this)(this.field().errors); // not sure why I need to bind this here.
	}

	renderErrors() {
		const errors = this.errors();
		if(!errors.length) { return null; }
		return (
			<ul className="errors-list">
				{errors.map(err => {
					return <li key={err}>* {err}</li>
				})}
			</ul>
        )
	}

    render() {
    	if (this.field()) {
			return (  
	            <div className={this.renderClasses()}>
	            	<label htmlFor={this.renderFor()} className="control-label">
			    		<span>{ this.field().label }</span>
			    		{this.renderRequired()}
					</label>
					{this.renderDescription()}
					{this.renderField()}
					{this.renderErrors()}
	            </div>
	        );
	    }
	    return null;
    }
}

GeckoField.defaultProps = {
    field: {},
    values: {},
    handler: () => {},
    onBlur: () => {}
};

export default GeckoField;